import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, message, Row,} from 'antd';
import ProForm, {ProFormInstance} from '@ant-design/pro-form';
import {WdiCardTitle, wdiCore, WdiInput, WdiModalAppResult} from '@/components/WdiControls';
import {FileUploadUtility, WdiFileUpload} from '@/components/WdiControls/WdiFileUpload';
import {Enum} from '@/enums/system';
import {ResponseStatus} from '@/utils/request';
import {FormPageProps} from '@/components/WdiBus/FormPage';
import {ApplyFooter, ApplyFooterType} from '@/components/WdiBus/ApplyFooter';
import {FormSp} from '@/services/sales/sp';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {initApplyPageContext, ViewEntityProps} from './data';
import {WdiSelect, WdiSelectFormat} from "@/components/WdiControls/WdiSelect";
import {DataOptions} from "@/services/basic/metadata";
import {BankAccount} from "@/services/mdm/bankaccount";
import PrePaymentDetailsForApplyPanel
  from "@/pages/sales/sp/PrePaymentApply/components/detail/PrePaymentDetailsForApplyPanel";
import {PageType} from "@/services/basic/pagetype";
import {SaSelectApp} from '@/pages/sales/sa/components/SaSelectApp';
import {OaContractSelectApp} from "@/pages/sales/sp/components/OaContractCmpt";
import {OaForm} from "@/services/mdm/oaform";
import {Company} from "@/services/mdm/company";
import {Supplier} from "@/services/mdm/supplier";
import {SoldTo} from "@/services/mdm/soldto";
import {Staff} from "@/services/basic/staff";
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

const getPageResult = (values: any, viewEntity: ViewEntityProps, pageType: API.PageType, statusId: number, dataSource: any[]) => {
  const result: WdiModalAppResult = {code: ResponseStatus.UNKNOWN};

  const {fileInfo, ...entity} = values;
  if (FileUploadUtility.isUploading(fileInfo)) {
    result.message = '附件正在上传中!';
    return result;
  }
  if (FileUploadUtility.isError(fileInfo)) {
    result.message = '附件存在错误文件!';
    return result;
  }
  const req: {form: any, formSp: any, formSpDetails: any[]} = {
    form: {
      statusId: statusId,
      pageTypeId: pageType.pageTypeId,
      pageGroupId: pageType.pageGroupId,
      formTypeId: viewEntity.formTypeId,
      userId: viewEntity.userId,
      positionId: viewEntity.positionId,
      deptId: viewEntity.deptId
    },
    formSp: {
      paymentMethodId: viewEntity.paymentMethodId,
      payToTypeId: viewEntity.payToTypeId,
      supplierId: viewEntity.supplierId,
      companyCode: viewEntity.companyCode,
      payToUserId: viewEntity.payToUserId,
      soldToCode: viewEntity.soldToCode,
    },
    formSpDetails: []
  };

  if (viewEntity.formSp) {
    if (viewEntity.relationType === Enum.FormRelationType.REJECTED) {
      // 退回待修改
      req.form.relatedFormId = viewEntity.relatedFormId;
      req.form.relationType = viewEntity.relationType;
    } else {
      // 从草稿打开
      req.form.formId = viewEntity.formId;
    }
  }

  entity.modifiedReason = '新建';
  entity.reimburseType = viewEntity.reimburseType;
  entity.invoiceStatus = Enum.InvoiceStatus.NON_INVOICE;
  entity.payTypeId = WdiSelectFormat.getvalue(values.payTypeId);
  entity.soldToCodePayTo = WdiSelectFormat.getvalue(values.soldToCodePayTo);
  entity.bankAccountId = WdiSelectFormat.getvalue(values.bankAccountId);
  entity.relatedSaNo = values.relatedSaNo.map((item: any) => item?.formNo).filter((item: any) => item).join()
  if (values?.oaFormNo) {
    entity.oaFormNo = values.oaFormNo.oaFormNo;
    entity.oaFormName = values.oaFormNo.oaFormName;
    entity.url = values.oaFormNo.url;
  }

  const info = FileUploadUtility.serialize(fileInfo);
  entity.fileName = info?.names;
  entity.filePath = info?.urls;
  req.formSp = Object.assign(entity, req.formSp);
  req.formSpDetails = JSON.parse(JSON.stringify(dataSource ?? []));
  for (let i = 0; i < req.formSpDetails.length; i++) {
    const detailRow = req.formSpDetails[i];
    detailRow.formSpDetailId = detailRow.formSpDetailId || 0;
    dataSource[i].formSpDetailId = detailRow.formSpDetailId;
    detailRow.formSpId = detailRow.formSpId || 0;
    dataSource[i].formSpId = detailRow.formSpId;
    // 需求变更 若所有行的都是0或空则报错 预付金额不能都为0
    detailRow.amountInVat = detailRow.amountInVat || 0;
  }

  result.data = req;
  result.code = ResponseStatus.SUCCESS;
  return result;
}

const PrePaymentApplyApp: React.FC<FormPageProps> = (props) => {

  const formRef = useRef<ProFormInstance>();
  const [entity, setEntity] = useState<ViewEntityProps>();
  const [bankAccountReloadKey, setBankAccountReloadKey] = useState<number>(0);
  const [spDetails, setSpDetails] = useState<API.FormSpDetail[]>([]);
  const [pageType, setPageType] = useState<API.PageType>();
  const [payType, setPayType] = useState<number>(0);
  const [editorRef, setEditorRef] = useState<any>();
  const [soldToCode, setSoldToCode] = useState<string>();
  const [payToSoldToCode, setPayToSoldToCode] = useState<string>();
  const [custSysCode, setCustSysCode] = useState<string>();

  const getFormSp = () => {
    const values = formRef.current?.getFieldsValue(['paymentMethodId', 'payTypeId', 'companyCode', 'supplierId', 'bankAccountId', 'oaFormNo', 'remark']);
    const formSp: API.FormSpPreVo = {
      paymentMethodId: values.paymentMethodId,
      payTypeId: WdiSelectFormat.getvalue(values.payTypeId),
      companyCode: WdiSelectFormat.getvalue(values.companyCode),
      supplierId: WdiSelectFormat.getvalue(values.supplierId),
      bankAccountId: WdiSelectFormat.getvalue(values.bankAccountId),
      oaFormNo: values.oaForm?.oaFormNo,
      remark: values.remark,
      formTypeId: Enum.FormType.PRE_PAYMENT,
      pageTypeId: Enum.PageType.PRE_PAYMENT_THIRD_PART,
      pageGroupId: Enum.PageGroup.PRE_PAYMENT,
      soldToCode: entity?.soldToCode
    }
    return formSp;
  }

  useEffect(() => {
    (async () => {
      if (props.setPageTitle) {
        let title = "预付申请";
        if (props.data?.formSpId) {
          title += '【编辑】'
        }
        props.setPageTitle(title);
      }
      const res = await initApplyPageContext(props.data ?? {});
      const viewEntity: ViewEntityProps = res?.data
      const formSp = viewEntity?.formSp;
      if (viewEntity?.pageTypeId) {
        PageType.get(viewEntity.pageTypeId).then(res => {
          setPageType(res?.data);
        })
      }
      if (formSp) {
        formRef.current?.setFieldsValue({
          paymentMethodId: formSp.paymentMethodId,
          paymentMethodName: formSp.paymentMethodName,
          payTypeId: formSp.payTypeId,
          bankAccountId: {
            value: formSp.bankAccountId,
            label: formSp.bankAccountCodeOrName
          },
          bankAccountName: formSp.bankAccountName,
          remark: formSp.remark,
          fileInfo: FileUploadUtility.parse(viewEntity.formSp?.fileName, viewEntity.formSp?.filePath),
          name: formSp.name,
          relatedSaNo: formSp.relatedSa,
          companyCodeOrName: wdiCore.String.CodeOrName(formSp.companyCode, formSp.companyName),
          supplierCodeOrName: wdiCore.String.CodeOrName(formSp.supplierCode, formSp.supplierName),
          payToUserCodeOrName: wdiCore.String.GenerateLabelDescription(wdiCore.String.CodeOrName(formSp.payToUserNo, formSp.payToUserName), formSp.payToUserTitle),
          soldToCodeOrName: wdiCore.String.CodeOrName(formSp.soldToCode, formSp.soldToName),
          soldToCodePayTo: {
            value: formSp.soldToCodePayTo,
            label: wdiCore.String.CodeOrName(formSp.soldToCodePayTo, formSp.soldToNamePayTo)
          },
        });
        setPayType(formSp.payTypeId ?? 0);
        if (formSp.oaFormNo) {
          OaForm.get(formSp.oaFormNo).then(res => {
            formRef.current?.setFieldsValue({
              oaFormNo: res.data,
            });
          })
        }
        setSoldToCode(formSp.soldToCode);
        setPayToSoldToCode(formSp.soldToCodePayTo);
      } else {
        await initEntityValue(viewEntity);
        setSoldToCode(viewEntity.soldToCode)
        setPayToSoldToCode(viewEntity.soldToCode);
      }
      setSpDetails(formSp?.preDetails ?? [])
      setEntity(viewEntity);
      setBankAccountReloadKey(bankAccountReloadKey + 1);
    })();
  }, []);

  useEffect(() => {
    if (!soldToCode) {
      setCustSysCode(undefined);
      return;
    }
    SoldTo.get(soldToCode).then(res => {
      setCustSysCode(res?.data?.custSysCode)
    })
  }, [soldToCode]);

  const initEntityValue = async (entity: ViewEntityProps) => {
    if (entity?.paymentMethodId) {
      DataOptions.search({
        typeGroup: 5,
        value: entity.paymentMethodId
      }).then(res => {
        const paymentMethod = res?.data.pop();
        formRef.current?.setFieldsValue({
          paymentMethodId: entity.paymentMethodId,
          paymentMethodName: paymentMethod?.name
        })
      })
    }
    if (entity?.companyCode) {
      Company.get(entity.companyCode).then(res => {
        formRef.current?.setFieldsValue({
          companyCodeOrName: res?.data?.codeOrName
        })
      })
    }
    if (entity?.supplierId) {
      Supplier.get(entity.supplierId).then(res => {
        formRef.current?.setFieldsValue({
          supplierCodeOrName: res?.data?.codeOrName
        })
      })
    }
    if (entity?.payToUserId) {
      Staff.get(entity.payToUserId).then(res => {
        formRef.current?.setFieldsValue({
          payToUserCodeOrName: wdiCore.String.GenerateLabelDescription(res?.data?.staffNoOrName, res?.data?.title)
        })
      })
    }
    if (entity?.soldToCode) {
      SoldTo.get(entity?.soldToCode).then(res => {
        formRef.current?.setFieldsValue({
          soldToCodeOrName: res?.data?.codeOrName,
          soldToCodePayTo: {value: res?.data?.soldToCode, label: res?.data?.codeOrName},
        })
      })
    }
  }


  return (
    <>
      <ProForm
        className={'wdi-form'}
        formRef={formRef}
        submitter={{
          render: () => {
            return (
              <ApplyFooter
                setLoading={props.setLoading}
                hiddenButton={[ApplyFooterType.Validate]}
                viewEntity={entity}
                submitBackUrl="/sales/sp/myprepayment"
                doSubmit={async (type: number, forceSubmit: boolean) => {
                  if (!entity || !pageType) {
                    return;
                  }
                  const remark = await editorRef?.current?.getHtml?.();
                  const values = await formRef.current?.validateFieldsReturnFormatValue?.();
                  if (values && values.errorFields && values.errorFields.length) {
                    return;
                  }
                  values.remark = remark;
                  const statusId = type === ApplyFooterType.Draft ? Enum.FormStatus.DRAFT : Enum.FormStatus.AWAITING;
                  const req = getPageResult(values, entity, pageType, statusId, spDetails);
                  if (req.code !== ResponseStatus.SUCCESS) {
                    message.error(req.message);
                    return;
                  }
                  props?.setLoading?.(true);
                  return await FormSp.Buttons.apply({
                    forceSubmit: forceSubmit,
                    ...req.data
                  });
                }}
                del={async () => {
                  if (!entity || !entity.formId) {
                    return;
                  }
                  return await FormSp.Buttons.del(entity.formId);
                }}
              />
            )
          }
        }}
      >
        <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.FORM_SP} title='预付单信息'/>}>
          <Row gutter={[16, 0]}>
            <Col className="gutter-row" span={4}>
              <Form.Item name="name" label="预付名称" rules={[{required: true, message: "预付名称不能为空!"}]}>
                <WdiInput/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item name="payTypeId" label="支付类型" rules={[{required: true, message: "支付类型不能为空!"}]}>
                <WdiSelect
                  {...{
                    placeholder: '请选择支付类型',
                    dataLoading: async (params) => {
                      const response = await DataOptions.search(Object.assign({
                        typeGroup: 106,
                        isActive: true
                      }, params));
                      return response.data.map((item) => {
                        return {value: item.value, label: item.name};
                      });
                    }
                  }}
                  onChange={(value) => {
                    setPayType(value);
                    formRef.current?.setFieldsValue({bankAccountId: null, bankAccountName: null});
                  }}
                />
              </Form.Item>
            </Col>
            {[Enum.PayToType.PAY_TO_SOLD_TO, Enum.PayToType.PAY_TO_SUPPLIER, Enum.PayToType.PAY_TO_STAFF].includes(entity?.payToTypeId ?? 0) &&
              <Col className="gutter-row" span={4}>
                <Form.Item name="companyCodeOrName" label="公司" rules={[{required: true, message: "公司不能为空!"}]}>
                  <WdiInput readOnly/>
                </Form.Item>
              </Col>
            }
            {[Enum.PayToType.PAY_TO_SUPPLIER].includes(entity?.payToTypeId ?? 0) &&
              <Col className="gutter-row" span={4}>
                <Form.Item name="supplierCodeOrName" label="供应商" rules={[{required: true, message: "供应商!"}]}>
                  <WdiInput readOnly/>
                </Form.Item>
              </Col>
            }
            {[Enum.PayToType.PAY_TO_STAFF].includes(entity?.payToTypeId ?? 0) &&
              <Col className="gutter-row" span={4}>
                <Form.Item name="payToUserCodeOrName" label="员工" rules={[{required: true, message: "员工不能为空!"}]}>
                  <WdiInput readOnly/>
                </Form.Item>
              </Col>
            }
            {[Enum.PayToType.PAY_TO_SOLD_TO].includes(entity?.payToTypeId ?? 0) &&
              [
                <Col className="gutter-row" span={4}>
                  <Form.Item name="soldToCodeOrName" label="客户" rules={[{required: true, message: "客户不能为空!"}]}>
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>,
                <Col className="gutter-row" span={4}>
                  <Form.Item name="soldToCodePayTo" label="收款客户"
                             rules={[{required: true, message: "收款客户不能为空!"}]}>
                    <WdiSelect
                      {...{
                        placeholder: '请选择收款客户',
                        remote: true,
                        labelInValue: true,
                        showSearch: true,
                        reloadKey: custSysCode,
                        dataLoading: async (params) => {
                          let soldToRes;
                          if (!custSysCode) {
                            soldToRes = await SoldTo.ajaxSearch(Object.assign({
                              isActive: true,
                              withPermissions: true,
                              soldToCodes: soldToCode
                            }, params))
                          } else {
                            soldToRes = await SoldTo.ajaxSearch(Object.assign({
                              isActive: true,
                              withPermissions: true,
                              custSysCode: custSysCode,
                            }, params))
                          }
                          return soldToRes?.data.map((item) => {
                            return {value: item.soldToCode, label: item.codeOrName};
                          });
                        }
                      }}
                      onChange={(value) => {
                        setPayToSoldToCode(WdiSelectFormat.getvalue(value))
                        setBankAccountReloadKey(bankAccountReloadKey + 1);
                        formRef.current?.setFieldsValue({bankAccountId: null, bankAccountName: null});
                      }}
                    />
                  </Form.Item>
                </Col>
              ]
            }

            <Col className="gutter-row" span={4}>
              <Form.Item name="bankAccountId" label="银行账号"
                         rules={[{required: payType == Enum.PayType.CASH, message: "银行账号不能为空!"}]}>
                <WdiSelect
                  {...{
                    placeholder: '请选择银行账号',
                    remote: true,
                    labelInValue: true,
                    showSearch: true,
                    dataLoading: async (params) => {
                      if (!bankAccountReloadKey) {
                        return []
                      }
                      const userId = entity?.payToUserId;
                      const response = await BankAccount.ajaxSearch(Object.assign({
                        isActive: true,
                        supplierId: entity?.supplierId,
                        soldToCode: payToSoldToCode,
                        userId: entity?.payToUserId,
                        //用户有值不限制公司
                        companyCode: userId ? null : entity?.companyCode,
                      }, params));
                      return response.data.map((item) => {
                        return {value: item.bankAccountId, label: item.codeOrName};
                      });
                    }
                  }}
                  onChange={(value) => {
                    const bankAccountId = WdiSelectFormat.getvalue(value);
                    if (!bankAccountId) {
                      formRef.current?.setFieldsValue({bankAccountName: undefined})
                      return;
                    }
                    BankAccount.get(bankAccountId).then(res => {
                      formRef.current?.setFieldsValue({bankAccountName: res?.data?.bankAccountName})
                    })
                  }}
                  reloadKey={bankAccountReloadKey}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={4}>
              <Form.Item name="bankAccountName" label="户名"
                         rules={[{required: payType == Enum.PayType.CASH, message: "户名不能为空!"}]}>
                <WdiInput/>
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={4}>
              <Form.Item name="relatedSaNo" label="相关活动单号"
                         rules={[{required: true, message: "相关活动单号不能为空!"}]}>
                <SaSelectApp
                  filterParams={{
                    statusIds: [8],
                    pageGroupIds: [Enum.PageGroup.ACTIVITY_APPLICATION, Enum.PageGroup.MKT_APPLICATION],
                    paymentMethodIds: [Enum.PaymentMethod.THIRD_PART, Enum.PaymentMethod.TRANSFER],
                  }}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item name="oaFormNo" label="OA合同号" rules={[{required: false, message: "OA合同号不能为空!"}]}>
                <OaContractSelectApp/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={4}>
              <Form.Item name="paymentMethodName" label="支付方式">
                <WdiInput readOnly/>
              </Form.Item>
              <Form.Item name="paymentMethodId" label="paymentMethodId" hidden>
                <WdiInput readOnly/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col className="gutter-row" span={16}>
              <Form.Item name="remark" label="备注" rules={[{required: true, message: "备注不能为空!"}]}>
                <WdiEditor setRef={setEditorRef}/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={8}>
              <Form.Item
                name="fileInfo"
                label="附件"
                valuePropName='fileList'
                getValueFromEvent={(e: any) => {
                  return e.fileList || [];
                }}
              >
                <WdiFileUpload leftTopInfo="请选择文件并上传(单个文件不能超500M)"/>
              </Form.Item>
            </Col>
          </Row>
        </WdiPanel>
        <PrePaymentDetailsForApplyPanel
          dataSource={spDetails}
          getFormSp={getFormSp}
          onChange={(spDetails: API.FormSpPreDetailVo[]) => {
            setSpDetails(spDetails);
          }}/>
      </ProForm>
    </>
  );
};

export default PrePaymentApplyApp;
